import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Tag } from 'antd';

import type { ModelClientField } from '@app/api/ClientFields';
import { generateSpanWithDataTestId } from '@app/shared/utils';

import { CLIENT_FIELDS_EMPTY_NAME } from '../data/constants';

import type { ClientFieldsColumnsHandlers } from '../types';
import type { ColumnsType } from 'antd/es/table';

export const getClientFieldsColumns = ({
  onEdit,
  onDelete,
  canEdit,
  canDelete,
}: ClientFieldsColumnsHandlers): ColumnsType<ModelClientField> => {
  const columns: ColumnsType<ModelClientField> = [
    {
      title: generateSpanWithDataTestId('Название', 'client-field-name-title'),
      dataIndex: 'Name',
      key: 'Name',
      render: (_, field) => field.Name?.trim() || CLIENT_FIELDS_EMPTY_NAME,
    },
    {
      title: generateSpanWithDataTestId(
        'Важное',
        'client-field-important-title'
      ),
      key: 'important',
      width: 120,
      render: (_, field) =>
        field.IsImportant ? <Tag color="blue">Важное</Tag> : null,
    },
    {
      title: generateSpanWithDataTestId('Статус', 'client-field-status-title'),
      key: 'status',
      width: 140,
      render: (_, field) =>
        field.IsDeleted ? (
          <Tag color="default">В архиве</Tag>
        ) : (
          <Tag color="green">Активно</Tag>
        ),
    },
  ];

  if (!canEdit && !canDelete) {
    return columns;
  }

  columns.push({
    title: '',
    key: 'actions',
    width: 100,
    align: 'right',
    render: (_, field) => (
      <div className="ClientFields__row-actions">
        {canEdit && (
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEdit(field)}
            data-testid="edit-client-field"
            aria-label="Редактировать поле"
          />
        )}
        {canDelete && (
          <Popconfirm
            title="Удалить поле?"
            description="Поле будет удалено у всех клиентов организации."
            okText="Удалить"
            cancelText="Отмена"
            okButtonProps={{ danger: true }}
            onConfirm={() => onDelete(field)}
          >
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              data-testid="delete-client-field"
              aria-label="Удалить поле"
            />
          </Popconfirm>
        )}
      </div>
    ),
  });

  return columns;
};
